


import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

import FieldError from '../fields/FieldError.vue';

@Component({
    components: {
        FieldError
    },
    computed: {
        ...mapGetters([
            "sectionFormOpen",
            "addressValid",
            "countries",
            "config",
            "formData"
        ])
    }
})
export default class AddressEditComponent extends Vue {
    @Prop() type!: string;

    public serversideErrors(field: string) {
        let found = this.$store.getters.sectionFieldErrors(this.type)
                .filter((item: any) => item.field === field)
        return found && found.length ? found[0].errors : []; 
    }

    public isInValid(value: string): boolean {
        return !this.$store.getters.addressValid(this.type === 'correspondence' ? this.$store.getters.formData.correspondence : this.$store.getters.formData.temporary) 
            && this.$store.getters.sectionFormSubmitted(this.type) 
            && !value
    }
}
